class WebEditorFormController {
  /* @ngInject */
  constructor(BROWSER_OS_PLATFORM) {
    this.BROWSER_OS_PLATFORM = BROWSER_OS_PLATFORM;
  }
}

export default WebEditorFormController;
